import * as React from 'react';
import type { SVGProps } from 'react';
const SvgQuestionCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10 16.56a6.56 6.56 0 1 0 0-13.12 6.56 6.56 0 0 0 0 13.12M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10.456 6.9c-.93-.316-1.579.2-1.765.52a.8.8 0 1 1-1.382-.806c.492-.845 1.878-1.836 3.663-1.228a2.7 2.7 0 0 1 1.677 1.667c.245.696.219 1.55-.286 2.2-.483.623-1.007 1.023-1.478 1.247a.4.4 0 0 0-.085.058v.242a.8.8 0 0 1-1.6 0v-.307c0-.758.586-1.242.998-1.438.223-.106.556-.338.901-.783.09-.116.154-.367.04-.687a1.1 1.1 0 0 0-.683-.684Z"
      clipRule="evenodd"
    />
    <path d="M11 13.8a1 1 0 1 1-1.999 0 1 1 0 0 1 1.999 0" />
  </svg>
);
export default SvgQuestionCircle;
